import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PrivateRoute = ({ roles, element }) => {
  const auth = useSelector((state) => state.auth);

  if (!auth.isAuthenticated) {
    // User is not authenticated
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(auth.user.role_name)) {
    // User does not have the required role
    return <Navigate to="/unauthorized" replace />;
  }

  // User is authenticated and has the required role
  return element;
};

export default PrivateRoute;
